<template>
    <v-card class="px-6 py-4">
        <v-row class="mx-4 mt-4">
            <v-col cols="8">
                <v-autocomplete outlined v-model="company_id" :items="companyLists" :loading="isLoadingCompany" :search-input.sync="searchCompanies" :hide-no-data="searchCompanies==''||searchCompanies==undefined||searchCompanies==null" item-text="name" item-value="id" label="Empresa" placeholder="Escribe para buscar" attach>
                    <template v-slot:item="{item, attrs, on}">
                        <v-list-item v-on="on" v-bind="attrs">
                            <v-list-item-content>
                                <v-list-item-title v-if="item.name!=null">
                                    <span v-if="item.macro!=null">{{item.macro}}</span>{{item.name}}
                                    <div v-if="item.razon_social!=null">
                                        <span style="font-size:12px;">{{item.razon_social}}</span>
                                    </div>
                                </v-list-item-title>
                                <v-list-item-title v-else-if="item.razon_social!=null">
                                    {{item.razon_social}}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template> 

                    <template slot="no-data">
                        <v-row class="ma-0 py-2 px-6">
                            <span>No existen clientes relacionados.</span>
                        </v-row>
                    
                    </template>    

                </v-autocomplete>
            </v-col>
            <v-col cols="4" class="pt-3" >
                <v-menu offset-y :close-on-content-click="closeDatePicker(date)">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field outlined :disabled="company_id==undefined" clearable  v-model="date" label="Fecha" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field><!--fecha programada-->
                    </template>
                    <v-date-picker v-model="date" range></v-date-picker>
                </v-menu>
            </v-col>

        </v-row>
        <div v-if="company!=undefined&&company.facturapi_id==null">
            <v-card-subtitle class="pb-0">
                Por favor verficia los datos del cliente
            </v-card-subtitle>
            <v-text-field v-model="company.razon_social" :error="nosa" hint="sin el régimen societario (ej.: S.A. de C.V.)." persistent-hint dense class="mt-3 mb-0 mx-3" label="Razón Social*" outlined></v-text-field>
            <v-row class="ma-0">
                <v-col cols="4" class="mt-2">
                    <v-text-field v-model="company.rfc" dense label="RFC*" outlined></v-text-field>
                </v-col>
                <v-col cols="4" class="mt-2">
                    <v-text-field v-model="company.fiscal_email" dense label="Email" outlined :hint="'Correo Principal: ' + company.email" persistent-hint></v-text-field>
                </v-col>
                <v-col cols="4" class="mt-2">
                    <v-autocomplete v-model="company.tax_system" dense label="Régimen Fiscal*" outlined :items="tax_systems" item-text="name" item-value="id"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <div style="text-align:center; background:whitesmoke; width:100%" class="py-3 mb-2">
                    {{company.address}}
                </div>
                <v-col cols="4" class="mt-2">
                    <v-text-field v-model="company.fiscal_address_json.street" dense label="Calle" outlined></v-text-field>
                </v-col>
                <v-col cols="4" class="mt-2">
                    <v-text-field v-model="company.fiscal_address_json.exterior" dense label="# Exterior" outlined></v-text-field>
                    </v-col>
                <v-col cols="4" class="mt-2">
                    <v-text-field v-model="company.fiscal_address_json.interior" dense label="# Interior" outlined></v-text-field>
                    </v-col>
                <v-col cols="4" class="mt-2">
                    <v-text-field v-model="company.fiscal_address_json.neighborhood" dense label="Colonia" outlined></v-text-field>
                    </v-col>
                <v-col cols="4" class="mt-2">
                    <v-text-field v-model="company.fiscal_address_json.city" dense label="Ciudad" outlined></v-text-field>
                    </v-col>
                <v-col cols="4" class="mt-2">
                    <v-text-field v-model="company.fiscal_address_json.municipality" dense label="Municipio" outlined></v-text-field>
                    </v-col>
                <v-col cols="3" class="mt-0">
                    <v-text-field v-model="company.fiscal_address_json.zip" dense label="Código Postal*" outlined></v-text-field>
                    </v-col>
                <v-col cols="3" class="mt-0">
                    <v-text-field v-model="company.fiscal_address_json.state" dense label="Estado" outlined></v-text-field>
                </v-col>
                <v-col cols="3" class="mt-0">
                    <v-text-field class="mb-2" v-model="company.fiscal_address_json.country" hint="Código de país acorde al estándar ISO 3166-1 alpha-3" persistent-hint dense label="Código de País" outlined></v-text-field>
                </v-col>
                <v-col cols="3" class="mt-0">
                    <v-autocomplete outlined dense clearable v-model="company.cfdi_use" :items="cfdi" label="Uso de CFDI" item-text="Descripción" item-value="Clave">
                        <template slot="no-data">No existen usos relacionados.</template>                      
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row class="ma-0 pt-0" style="margin-top:-30px!important;">
                <v-spacer/>
                <v-btn rounded color="primary" @click="saveClient()" class="elevation-0" small :disabled="readyToSave || savingCLient">Validar Caliente</v-btn>
            </v-row>
        </div>
        
        <v-data-table 
            v-model="selected_sales"
            item-key="id"
            show-select
            :items="salesList" 
            :headers="headers" 
            :options.sync="options" 
            :loading="loading" 
            class="mb-6"
            :server-items-length="totalSales"
             :footer-props="{'items-per-page-options':[15, 30, 50, totalSales]}"
        ></v-data-table>
        
        <v-row class="ma-0">
            <v-col cols="4" class="pb-0">
                <v-autocomplete v-model="invoice.payment_form" dense label="Forma de Pago" outlined :items="payment_forms" item-text="text" item-value="value"></v-autocomplete>
            </v-col>
            <v-col cols="4" class="pb-0">
                <v-autocomplete v-model="invoice.payment_method" dense label="Método de Pago" outlined :items="payment_methods" item-text="text" item-value="value"></v-autocomplete>
            </v-col>
            <v-col cols="4" class="pb-0">
                <v-autocomplete v-model="invoice.use" dense label="Uso de CFDI" outlined :items="cfdi" item-text="Descripción" item-value="Clave"></v-autocomplete>
            </v-col>
        </v-row>

        <v-card-actions>
            <v-row class="ma-0">
                <v-spacer/>
                <v-btn class="mr-4 elevation-0" text @click="close(false)">Cancelar</v-btn>
                <v-btn class="elevation-0" color="primary" :disabled="is_saving||selected_sales.length<1||company_id==undefined" :loading="is_saving" text @click="generateGlobalInvoice()">Generar Fctura</v-btn>
            </v-row>
        </v-card-actions>

        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>

<script>
import fiscal_catalogs from '../../mixins/fiscal_catalogs'
import axios from "axios"
export default {
    mixins: [fiscal_catalogs],
    data: () => ({
        invoice:{
            payment_form:'',
            payment_method:'',
            use:''
        },
        selected_sales:[],
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        company_id:undefined,
        date:undefined,
        entries:{
            companies: []
        },
        isLoadingCompany: false,
        searchCompanies: null,
        salesList:[],
        loading:false,
        options: {},
        is_saving:false,
        company:undefined,
        savingCLient:false,
        totalSales:0
    }),
    computed:{
        readyToSave(){
            if(this.company.razon_social!=undefined&&this.company.rfc!=undefined&&this.company.tax_system!=undefined&&this.company.fiscal_address_json.zip!=undefined&&
            this.company.razon_social!=null&&this.company.rfc!=null&&this.company.tax_system!=null&&this.company.fiscal_address_json.zip!=null&&
            this.company.razon_social!=''&&this.company.rfc!=''&&this.company.tax_system!=''&&this.company.fiscal_address_json.zip!=''){
                return false
            }else{
                return true
            }
        },
        nosa(){
            if(this.company.razon_social!=undefined && (
                this.company.razon_social.toLowerCase().includes('s.a. de c.v')||
                this.company.razon_social.toLowerCase().includes('sa de cv')||
                this.company.razon_social.toLowerCase().includes('sapi de cv')||
                this.company.razon_social.toLowerCase().includes('sapi')||
                this.company.razon_social.toLowerCase().includes('s.a de c.v')||
                this.company.razon_social.toLowerCase().includes('s. c')||
                this.company.razon_social.toLowerCase().includes('s.c')||
                this.company.razon_social.toLowerCase().includes('s.a.s')||
                this.company.razon_social.toLowerCase().includes('s. a. s')||
                this.company.razon_social.toLowerCase().includes('rl de cv')
            )){
                return true
            }else{
                return false
            }
        },
        cfdi(){
            return this.$store.state.cfdi.uses
        },
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        headers(){
            return [
                { text: 'Folio', value: 'id' },
                { text: this.liga=='https://backendmf.unocrm.mx/'?'Comedor':'Sucursal', value: 'company_branch' },
                { text: 'Fecha', value: 'date' },
                this.liga!='https://backendmf.unocrm.mx/'?{ text: 'Subtotal', value: 'subtotal' }:'',
                this.liga!='https://backendmf.unocrm.mx/'?{ text: 'IVA', value: 'iva' }:'',
                { text: 'Total', value: this.liga!='https://backendmf.unocrm.mx/'?'total':'subtotal' },
            ]
        },
        companyLists(){
            return this.entries.companies.map(id => {
                return{
                    id:id.id,
                    macro:id.attributes.macro,
                    name:id.attributes.name,
                    razon_social:id.attributes.razon_social,
                    price_list:id.attributes.price_list
                }
            })
        }, 
    },
    methods:{
        closeDatePicker(dates){
            if(dates!=undefined && dates.length==2){
                return true
            }else{
                return false
            }
        },
        saveClient(){
            this.savingCLient = true
            var facturApiClient = [this.company].map(id=>{return{
                legal_name: id.razon_social,
                email: id.fiscal_email,
                tax_id: id.rfc,
                address: id.fiscal_address_json,
                tax_system: id.tax_system,
            }})[0]
            let config = {
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"),
                    'Content-Type': "application/json"
                }
            }
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/customers", facturApiClient, config).then(response => {
                this.company.facturapi_id = response.data.id
                this.company.validation = true
                axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/companies/" + this.company.id, this.company).then(response => {
                    this.savingCLient = false
                    this.snackbar = {
                        message: 'Datos actualizados con éxito',
                        color: 'success',
                        show: true
                    }
                })
            }).catch(error => {
                this.savingCLient = false
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            })
        },
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.salesList = data.items
                this.totalSales = data.total
                this.loading = false
            })
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                var items = []
                var total = 0
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales?filter[company_id]=" + this.company_id + (this.date!=undefined&&this.date.length==2?('&filter[date]='+this.date):'') + "&filter[doesnt_have_invoices]=0&page=" + page + "&itemsPerPage=" + itemsPerPage).then(response => {
                    items = this.mapSales(response.data.data)
                    total = response.data.meta.total
                    resolve({
                        items,
                        total,
                    })
                })
            })
        },
        mapSales(sales){
            sales = sales.map(id=>{
                return{
                    selected:false,
                    id:id.id,
                    company_branch:id.company_branch?.name,
                    total:(id.total*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    date:id.date,
                    items:id.items.map(item=>{
                        return{
                            cost: item.cost,
                            id: item.id,
                            item: item.item,
                            price: item.price,
                            quantity: item.quantity,
                            quotation: item.quotation,
                            rejection_status: item.rejection_status,
                            value: item.value,
                            is_in_production:id.is_in_production,
                            production_dispatched:id.production_dispatched,
                            discount:item.discount!=null&item.item.discount!=undefined?item.discount + '%':0
                        }
                    }),
                    created_at:id.created_at.slice(0, 18),
                    updated_at:id.updated_at.slice(0, 18),
                    subtotal:(id.subtotal*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    iva:(id.iva*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})
                }
            });
            return sales
        },
        generateGlobalInvoice(){
            const global_invoice = {
                customer:this.company.facturapi_id,
                company_id:this.company.id,
                sales:this.selected_sales.map(s=>s.id),
                ...this.invoice
            }
            this.is_saving = true
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/global-invoice", global_invoice).then(response=>{
                this.company_id = undefined
                this.close(true)
            }).catch(error=>{
                this.is_saving = false
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'red',
                    show: true
                }
            })
        },
        close(param){
            this.$emit("closeGlobalInvoiceDialog", param);
        }
    },
    watch:{
        searchCompanies(val){
            if(val!=undefined&&val!=null){
                //if (this.companyLists.length > 0) return
                if (this.isLoadingCompany) return
                this.isLoadingCompany = true
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/companies?filter[name_razon_social]='+val)
                .then(res => {
                    /*if(this.entries.companies.length>0){
                        this.entries.companies(res.data.data)
                    }else{*/
                        this.entries.companies = res.data.data
                    //}
                }).finally(() => (this.isLoadingCompany = false))
            }
        },
        company_id:{
            handler(){
                if(this.company_id!=undefined){
                    this.company = this.entries.companies.filter(c=>c.id == this.company_id).map(c=>{return{
                        id:c.id,
                        ...c.attributes
                    }})[0]
                    this.getDataFromApi()
                }else{
                    this.salesList = []
                }
            }, deep:true
        },
        date:{
            handler(){
                if(this.date!=undefined&&this.date.length==2){
                    this.getDataFromApi()
                }else{
                    this.salesList = []
                }
            }, deep:true
        },
        options: {
            handler () {
                if(this.company_id!=undefined){
                    this.getDataFromApi()
                }
            },
            deep: true,
        },
    },
}
</script>

<style>

</style>
